import { KeyCodes } from 'bootstrap-vue/src/utils';
import { isTlsAvailable } from '@/utils/tls-available';

export default {
    bind(el, binding, vnode) {
        let targetHref;
        let isModalShowing = false;

        el.addEventListener('click', (evt) => {
            targetHref = el.getAttribute('href');

            if(!isTlsAvailable() && targetHref.match(/sso\.heart\.org/)) {
                evt.preventDefault();

                isModalShowing = true;
                vnode.context.$root.$emit('bv::show::modal', binding.value, vnode.elm);
            }
        });

        el.addEventListener('keypress', (evt) => {
            evt.preventDefault();

            if(evt.keyCode === KeyCodes.ENTER) {
                isModalShowing = true;
                vnode.context.$root.$emit('bv::show::modal', binding.value, vnode.elm);
            }
        });

        vnode.context.$root.$on('bv::modal::hide', (evt) => {
            if(isModalShowing) {
                isModalShowing = false;
            }
        });

        vnode.context.$root.$on('bv::modal::hidden', (evt) => {
            if(window.activeSssoIntercept) {
                window.activeSssoIntercept.focus();
                window.activeSssoIntercept = null;
            }
        });

        if(el.tagName !== 'BUTTON') {
            // If element is not a button, we add `role="button"` for accessibility
            el.setAttribute('role', 'button');
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/sso-intercept.js